export default __webpack_public_path__ + "static/q_myname-d8f2b05c32c47198f008b04b335deb1a.png";